import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Accordion, AccordionDetails, Typography, AccordionSummary } from "@material-ui/core";
import SimpleInput from "../../components/Frequents/SimpleInput";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import update from "immutability-helper";

const useStyles = makeStyles(theme => ({
    root: {
        width: "100%"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15)
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary
    },
    icon: {
        verticalAlign: "bottom",
        height: 20,
        width: 20
    },
    details: {
        display: "flex",
        flexDirection: "column"
    },
    column: {
        flexBasis: "40%"
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2)
    },
    link: {
        color: theme.palette.primary.main,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    }
}));

export default props => {
    const classes = useStyles();
    const tempTreatments = props.treatments;
    return (
        <div className={classes.root}>
            {tempTreatments.map((treatment, index) => {
                const time = Number(treatment["duration"] / 60).toString();
                const pause = Number(treatment["pause"] / 60).toString();
                return (
                    <Accordion key={treatment.id}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1c-content"
                            id="panel1c-header">
                            <div className={classes.column}>
                                <Typography className={classes.heading}>{treatment["name"]}</Typography>
                            </div>
                            <div className={classes.column}>
                                <Typography className={classes.secondaryHeading}>
                                    {time} min + {pause} min pause
                                </Typography>
                                <Typography className={classes.secondaryHeading}>{treatment["price"]} DKK</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails className={classes.details}>
                            {props.columns.map(column => {
                                const value = treatment[column.id];
                                if (column.id === "slet") return <></>;
                                return (
                                    <div style={{ width: "100%" }}>
                                        <SimpleInput
                                            disabled={column.id === "pause" && props.therapist.plan !== "pro"}
                                            text={column.label}
                                            type={column.id === "name" ? "text" : "number"}
                                            prop={
                                                value === null
                                                    ? null
                                                    : column.type === "text"
                                                    ? value
                                                    : column.type === "time"
                                                    ? Number(value / 60).toString()
                                                    : Number(value).toString()
                                            }
                                            changeValue={async value => {
                                                await props.saveTreatment(
                                                    update(tempTreatments, {
                                                        [index]: {
                                                            $set: update(treatment, {
                                                                [column.id]: {
                                                                    $set: column.type === "time" ? value * 60 : value
                                                                }
                                                            })
                                                        }
                                                    }),
                                                    index
                                                );
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </AccordionDetails>
                    </Accordion>
                );
            })}
        </div>
    );
};
